/// <amd-module name="Feed/Connect/Protocols/Upack" />
import { IPageData } from "VSS/Platform/Page";

import * as Res from "Feed/Connect/Resources";
import { PackagingService } from "Feed/Core/PackagingService";
import { IUxFeedView } from "Feed/Core/UxFeedView";

import { PackagingProcotol } from "../Protocol";
import { PackagingTool, ToolId } from "../Tool";

class UpackProtocol extends PackagingProcotol {
    constructor() {
        super("Universal");
    }

    public readonly area = "upack"; // ?

    public getFeedUrl(packagingService: PackagingService, feed: IUxFeedView) {
        // shouldn't be called
        return "";
    }
}

const Upack = new UpackProtocol();

class UPackTool extends PackagingTool {
    constructor(id: ToolId, name: string, imageName: string, private toolLinkId: number) {
        super(id, name, Upack, { src: `ms.feed/feed-connect/Content/${imageName}` }, false);
    }

    public getToolLink = () => ({
        href: `https://go.microsoft.com/fwlink/?linkid=${this.toolLinkId}`,
        children: `${Res.CommandLineReference}`
    });

    public isEnvironmentSupported = (pageData: IPageData): boolean => {
        return pageData.isHosted;
    }
}

export const UniversalPackages = new UPackTool(
    ToolId.UniversalPackages,
    "Universal packages",
    "universal-package.svg",
    2103692
);
